<!--
 * @Description: 描述
 * @Author: D
 * @Date: 2024-03-14 14:10
 * @LastEditTime: 2024-06-24 15:40
 * @LastEditors: D
 * @FilePath: \admin\src\Layout\Aside\menu.vue
-->
<template>
  <el-sub-menu
    :index="data.id"
    v-if="data && data.children && data.children.length > 0 && data.isShow == 1"
  >
    <template #title>
      <i :class="data.icon"></i>
      <span class="big-title">{{ data.name }}</span>
    </template>

    <MenuItem v-for="item in data.children" :key="item.path" :data="item">
    </MenuItem>
  </el-sub-menu>
  <el-menu-item
      :index="data.path"
      :route='{ path: data.path
    ,query:(data.routerParams && !data.routerParams.includes("="))?JSON.parse(data.routerParams):{}}'
    v-else-if="
      data && data.children && data.children.length == 0 && data.isShow == 1
    "
  >
    <i :class="data.icon"></i>
    <span slot="title">{{ data.name }}</span>
  </el-menu-item>
</template>


<!-- :index="data.path"
    :route='{ path: data.path
    ,query:(data.routerParams && !data.routerParams.includes("="))?JSON.parse(data.routerParams):{}}'-->
<script>
import MenuItem from "./menu.vue";
import {useStore} from "vuex";
export default {
  name: "MenuItem",
  components: { MenuItem },
  props: {
    data: {
      default: () => null,
      type: Object,
    },
  },
  data() {
    return {
      store: useStore(),
    };
  },

  mounted() {},

  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    clickMenu(item) {
      console.log(this.data,"menuKey7");
      // const store = useStore();
      this.store.state.curentLeftMenu = this.data;
      console.log(this.store.state.curentLeftMenu, "menuKey6")
      this.$router.push({ path: this.data.path
        ,query:(this.data.routerParams && !this.data.routerParams.includes("="))?JSON.parse(this.data.routerParams):{}});
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;

  .chart {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #545c64;
    font-weight: bold;
    font-size: 26px;
  }

  .logo {
    display: block;
    width: 100px;
    height: 100px;
    margin: 0 auto;
  }
  .big-title {
    font-size: 16px;
  }
}

.el-menu {
  height: calc(100% - 100px);
  border: 0 !important;
}
</style>
